import { experiments } from '../experiments';

export const isChatbotImageMultimodalityEnabled = (): boolean =>
  experiments.is('chatbotImageMultimodality', 'B');
